module.exports = __webpack_public_path__ + "static/img/mongodb.e5eee31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/mongodb.png
// module id = 521
// module chunks = 1